import formComponent from '@/util/proto/formComponent'

export default {
  extends: formComponent,
  data() {
    return {
      formData: {
        name: {
          rules: [
            { required: true, message: '请输入设备名称', trigger: 'blur,change' },
          ]
        },
        deviceType:{
          rules: [
            { required: true,type: 'number',  message: '请选择设备类型', trigger: 'blur,change' },
          ]
        },
        platform: {
          rules: [
            { required: true,type: 'number',  message: '请选择设备厂商', trigger: 'blur,change' },
          ]
        },
        companyId: {
          rules: [
            { required: true,type: 'number',  message: '请选择所属单位', trigger: 'blur,change' },
          ]
        },
        deviceSn:{
          rules: [
            { required: true, message: '请输入设备编码', trigger: 'blur,change' },
          ]
        },
        deviceModel:{
          rules: [
            { required: true, message: '请输入设备型号', trigger: 'blur,change' },
          ]
        }
      },
      
      id: null,
      loading: false,
      visible: false,
      api:['companyDeviceCreate','companyDeviceUpdate']
    }
  },

  created() {

  },
  computed: {
    itemTitle() {
      return this.id ? '编辑设备信息' : '新增设备信息'
    }
  },

  methods: {
    init(id) {
      this.id = id
      this.reset()
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.loading = true
      this.$request.companyDevice(this.id).then(resp => {
        this.loading = false
        this.$setFormData(resp.data)
      })
    },
    reset() {
      this.$resetFormData()
    },

    beforeSave(d){
      if(this.id) d.id = this.id
      return d
    }

  },

  render(){
    return  <sl-side-panel v-model={this.visible} loading={this.loading} mask-closable={false} title={this.itemTitle}>
        <sl-form label-width={110}>
          <sl-form-item label="设备名称">
            <Input v-decorator={this.formData.name} maxlength={128}></Input>
          </sl-form-item>
          <sl-form-item label="设备类型">
            <sl-select dict="companyDeviceType" filterable={true} placeholder="选择设备类型" v-decorator={this.formData.deviceType} />
          </sl-form-item>
          <sl-form-item label="设备厂商">
            <sl-select dict="companyDevicePlatform" filterable={true} placeholder="选择设备厂商" v-decorator={this.formData.platform} />
          </sl-form-item>
          <sl-form-item label="设备型号">
            <Input v-decorator={this.formData.deviceModel} placeholder="选择设备型号" maxlength={128}></Input>
          </sl-form-item>
          <sl-form-item label="设备编码">
            <Input v-decorator={this.formData.deviceSn} placeholder="选择设备编码" maxlength={128}></Input>
          </sl-form-item>
          <sl-form-item label="所属单位">
            <sl-select dict="company" filterable={true} placeholder="选择所属单位" v-decorator={this.formData.companyId}/>
          </sl-form-item>

        </sl-form>
        <div slot="footer">
          <Button loading={this.loading} on-click={this.$handleSubmit} type="primary">确定</Button>
        </div>
    </sl-side-panel>
  }
}


export const View = {
  data() {
    return {
      data: {},
      visible:false,
    }
  },


  methods: {

    init(id) {
      this.id = id
      this.visible = true
      if (this.id) {
        this.query()
      }
    },

    query() {
      this.$request.companyDevice(this.id).then(resp => {
        this.data = this.$utils.conv(resp.data , {'deviceType':'companyDeviceType','platform':'companyDevicePlatform' })
      })
    }
  },

  render(){
    const data = this.data || {}
    //col={3} layout="vertical"

    const title = '查看设备'
    return (
      <sl-side-panel v-model={this.visible} mask-closable={false} title={title}>
        <sl-detail-list label-width="110px" col={1} label-align="right" style="padding:12px;">
          <sl-detail-list-item title="类型名称" content={data.name} />
          <sl-detail-list-item title="设备类型" content={data.deviceTypeText} />
          <sl-detail-list-item title="设备厂商" content={data.platformText} />
          <sl-detail-list-item title="设备型号" content={data.deviceModel} />
          <sl-detail-list-item title="设备编码" content={data.deviceSn} />
          <sl-detail-list-item title="所属单位" content={data.companyName} />
        </sl-detail-list>
      </sl-side-panel>
    )
  }
}